import { AccessPolicy } from '@chr/online-shared-microsite-core/types';
import { IPostApprovePoRequest } from '../../../../interfaces/api-requests/approve-po-request';
import { IPostHoldRequestRequest } from '../../../../interfaces/api-requests/post-hold-request-request';
import { IReleaseHoldRequestPayload } from './interfaces/release-hold-request-payload';

//#region po details

export const PO_DETAILS_ACTIONS = {
  REQUEST: 'PO_DETAILS_REQUEST',
  SUCCESS: 'PO_DETAILS_SUCCESS',
  FAILURE: 'PO_DETAILS_FAILURE',
  CLEAR: 'PO_DETAILS_CLEAR',
  REMEMBER_TAB: 'PO_DETAILS_REMEMBER_TAB',
  REMOVE_UNREAD: 'PO_DETAILS_REMOVE_UNREAD',
  MARK_PO_AS_READ: 'PO_DETAILS_MARK_PO_AS_READ',
  FOLLOWUP_ERROR: 'CONVERSATION_FOLLOWUP_ERROR',
  FOLLOWUP_DELETE_REQUEST: 'CONVERSATION_FOLLOWUP_DELETE_REQUEST',
  FOLLOWUP_DELETE_SUCCESS: 'CONVERSATION_FOLLOWUP_DELETE_SUCCESS',
  FOLLOWUP_PUT_REQUEST: 'CONVERSATION_FOLLOWUP_PUT_REQUEST',
  FOLLOWUP_PUT_SUCCESS: 'CONVERSATION_FOLLOWUP_PUT_SUCCESS',
};

export function getPoDetailsRequest(poId) {
  return {
    poId,
    type: PO_DETAILS_ACTIONS.REQUEST
  };
}

export function getPoDetailsSuccess(payload) {
  return {
    payload,
    type: PO_DETAILS_ACTIONS.SUCCESS
  };
}

export function getPoDetailsFailure(error) {
  return {
    error,
    type: PO_DETAILS_ACTIONS.FAILURE
  };
}

export function clearPoDetails() {
  return {
    type: PO_DETAILS_ACTIONS.CLEAR
  };
}

export const rememberActiveTabAction = (bucketTypeId: number) => ({
  bucketTypeId,
  type: PO_DETAILS_ACTIONS.REMEMBER_TAB
});

export const removeUnreadFromPoConversation = () => ({
  type: PO_DETAILS_ACTIONS.REMOVE_UNREAD
});

export const markPoAsRead = (purchaseOrderId: number) => ({
  purchaseOrderId,
  type: PO_DETAILS_ACTIONS.MARK_PO_AS_READ
});

export function conversationFollowupFailureAction(error) {
  return {
    error,
    type: PO_DETAILS_ACTIONS.FOLLOWUP_ERROR
  };
}

export function deletePoConversationFollowupRequest(request) {
  return {
    request,
    type: PO_DETAILS_ACTIONS.FOLLOWUP_DELETE_REQUEST
  };
}

export function deletePoConversationFollowupSuccess(request) {
  return {
    request,
    type: PO_DETAILS_ACTIONS.FOLLOWUP_DELETE_SUCCESS
  };
}

export function putPoConversationFollowupRequest(request) {
  return {
    request,
    type: PO_DETAILS_ACTIONS.FOLLOWUP_PUT_REQUEST
  };
}

export function putPoConversationFollowupSuccess(request) {
  return {
    request,
    type: PO_DETAILS_ACTIONS.FOLLOWUP_PUT_SUCCESS
  };
}

//#endregion

//#region po items

export const PO_ITEMS_ACTIONS = {
  REQUEST: 'PO_ITEMS_REQUEST',
  SUCCESS: 'PO_ITEMS_SUCCESS',
  FAILURE: 'PO_ITEMS_FAILURE',
  FILTER: 'PO_ITEMS_FILTER',
  SEARCH: 'PO_ITEMS_SEARCH',
  CONFIRM_SELECTED_SUCCESS: 'CONFIRM_SELECTED_SUCCESS'
};

export function getPoItemsRequest(payload) {
  return {
    payload,
    type: PO_ITEMS_ACTIONS.REQUEST
  };
}

export function getPoItemsSuccess(payload) {
  return {
    payload,
    type: PO_ITEMS_ACTIONS.SUCCESS
  };
}

export function getPoItemsFailure(error) {
  return {
    error,
    type: PO_ITEMS_ACTIONS.FAILURE
  };
}

export function filterPoItems(payload) {
  return {
    payload,
    type: PO_ITEMS_ACTIONS.FILTER
  };
}

export function searchPoItems(searchText: string, userAccessPolicies: AccessPolicy[]) {
  return {
    searchText,
    userAccessPolicies,
    type: PO_ITEMS_ACTIONS.SEARCH,
  };
}

export function approveSelectedItemsSuccess(payload) {
  return {
    payload,
    type: PO_ITEMS_ACTIONS.CONFIRM_SELECTED_SUCCESS
  };
}

//#endregion

//#region PoItems Revised

export const POITEMS_REVISED_ACTIONS = {
  REQUEST: 'POITEMS_REVISED_CONFIRMED_REQUEST',
  SUCCESS: 'POITEMS_REVISED_CONFIRMED_SUCCESS',
  FAILURE: 'POITEMS_REVISED_CONFIRMED_FAILURE'
};

export function getPoItemsRevisedRequest(payload) {
  return {
    payload,
    type: POITEMS_REVISED_ACTIONS.REQUEST
  };
}

export function getPoItemsRevisedSuccess(payload) {
  return {
    payload,
    type: POITEMS_REVISED_ACTIONS.SUCCESS
  };
}

export function getPoItemsRevisedFailure(error) {
  return {
    error,
    type: POITEMS_REVISED_ACTIONS.FAILURE
  };
}

//#endregion

//#region Confirmed po items

export const CONFIRMED_PO_ITEMS_ACTIONS = {
  REQUEST: 'CONFIRMED_PO_ITEMS_REQUEST',
  SUCCESS: 'CONFIRMED_PO_ITEMS_SUCCESS',
  FAILURE: 'CONFIRMED_PO_ITEMS_FAILURE',
  FILTER: 'CONFIRMED_PO_ITEMS_FILTER'
};

export function getConfirmedPoItemsRequest(payload) {
  return {
    payload,
    type: CONFIRMED_PO_ITEMS_ACTIONS.REQUEST
  };
}

export function getConfirmedPoItemsSuccess(payload) {
  return {
    payload,
    type: CONFIRMED_PO_ITEMS_ACTIONS.SUCCESS
  };
}

export function getConfirmedPoItemsFailure(error) {
  return {
    error,
    type: CONFIRMED_PO_ITEMS_ACTIONS.FAILURE
  };
}

export function filterConfirmedPoItems(payload) {
  return {
    payload,
    type: CONFIRMED_PO_ITEMS_ACTIONS.FILTER
  };
}

//#endregion

//#region approve po

export const APPROVE_PO_ACTIONS = {
  REQUEST: 'APPROVE_PO_REQUEST',
  SUCCESS: 'APPROVE_PO_SUCCESS',
  FAILURE: 'APPROVE_PO_FAILURE'
};

export function postApprovePoRequest(payload: IPostApprovePoRequest) {
  return {
    payload,
    type: APPROVE_PO_ACTIONS.REQUEST
  };
}

export function postApprovePoSuccess(response) {
  return {
    response,
    type: APPROVE_PO_ACTIONS.SUCCESS
  };
}

export function postApprovePoFailure(error) {
  return {
    error,
    type: APPROVE_PO_ACTIONS.FAILURE
  };
}

//#endregion

//#region details bucket totals

export const PO_DETAILS_BUCKET_TOTALS_ACTIONS = {
  REQUEST: 'PO_DETAILS_BUCKET_TOTALS_REQUEST',
  SUCCESS: 'PO_DETAILS_BUCKET_TOTALS_SUCCESS',
  FAILURE: 'PO_DETAILS_BUCKET_TOTALS_FAILURE'
};

export function getPoDetailsBucketTotalsRequest(payload) {
  return {
    payload,
    type: PO_DETAILS_BUCKET_TOTALS_ACTIONS.REQUEST
  };
}

export function getPoDetailsBucketTotalsSuccess(response) {
  return {
    response,
    type: PO_DETAILS_BUCKET_TOTALS_ACTIONS.SUCCESS
  };
}

export function getPoDetailsBucketTotalsFailure(error) {
  return {
    error,
    type: PO_DETAILS_BUCKET_TOTALS_ACTIONS.FAILURE
  };
}

//#endregion

//#region po items hold request

export const HOLD_REQUEST = {
  CREATE_SUCCESS: 'DETAILS_CREATE_HOLD_SUCCESS',
  RELEASE_SUCCESS: 'DETAILS_RELEASE_HOLD_SUCCESS'
};

export const detailsCreateHoldSuccess = (payload: IPostHoldRequestRequest) => ({
  payload,
  type: HOLD_REQUEST.CREATE_SUCCESS
});

export const detailsReleaseHoldSuccess = (payload: IReleaseHoldRequestPayload) => ({
  payload,
  type: HOLD_REQUEST.RELEASE_SUCCESS
});

//#endregion
